export default "__VITE_ASSET__7334c219__"